// removed by extract-text-webpack-plugin
module.exports = {"EkycCheckingInfo":"EkycCheckingInfo","btnContainer":"btnContainer","EkycCheckingInfoMobile":"EkycCheckingInfoMobile","form-row":"form-row"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Step3/CheckingInfo/style.scss
// module id = 2305
// module chunks = 10